import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import React from 'react';
import ContractTab from '../tabs/contract/ContractTab';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import TabList from '@mui/lab/TabList';
import TabContext from '@mui/lab/TabContext';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../../store/rootReducer';
import TabPanel from '@mui/lab/TabPanel';
import { setActiveTab } from '../../../../../../../store/brand/contractBrandSlice';
import ContractIdeaContent from '../tabs/idea/ContractIdeaContent';
// import { ContractReviews } from '../tabs/reviews/ContractReviews';
import { ContractHistory } from '../tabs/history/ContractHistory';
import ContractAudienceData from '../tabs/audience/ContractAudienceData';
import { OfferComments } from '../../../../../../../shared/components/offer/offer-comments/OfferComments';
import { ContractAnnexPending } from '../../../../../../../shared/components/offer/ContractAnnexPending';
import { AnnexBaseTab } from '../../../../../../../shared/components/offer/AnnexBaseTab';

function ContractModalTabs() {
    const { activeTabModal, campaign, canWriteComment, hasUnreadComments, isAnnexMode } = useSelector(
        (state: IAllStates) => state.contractBrand
    );
    const { isClient } = useSelector((state: IAllStates) => state.auth.user);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const isInvited = location.pathname.split('/').includes('invite') || !campaign?.contracts?.length;
    const isMobile = window.innerWidth <= 700;
    const isProposed = campaign?.contracts?.[0]?.isProposed;
    // The amended contract stays in the Contract tab, the amendment (or its editor) is in its own tab
    const hasAnnexTab = !!campaign?.annexBase;

    const handleTab = (event: React.SyntheticEvent, newValue: string) => {
        dispatch(setActiveTab(newValue));
    };

    return (
        <Box sx={{ width: '100%' }}>
            <TabContext value={activeTabModal}>
                <Box className="mb-md-3 position-sticky">
                    <TabList
                        allowScrollButtonsMobile={isMobile}
                        variant={isMobile ? 'scrollable' : 'fullWidth'}
                        onChange={handleTab}
                        centered
                    >
                        <Tab label={t('brand.campaign.book.contract.modal.contract')} value="0" />
                        {hasAnnexTab && <Tab label={t('brand.campaign.book.contract.modal.annex.label')} value="6" />}
                        <Tab label={t('brand.campaign.book.offer.modal.content')} value="1" />
                        <Tab label={t('brand.campaign.book.offer.modal.audience')} value="2" />
                        {/* {!isClient && !isProposed && (
                            <Tab label={t('brand.campaign.book.offer.modal.reviews')} value="3" />
                        )} */}
                        {!isInvited && !isClient && !isProposed && (
                            <Tab
                                label={t('brand.campaign.book.offer.modal.comments')}
                                icon={<> {hasUnreadComments && <span className="notification-comment-badge"></span>}</>}
                                value="4"
                            />
                        )}
                        {!isClient && campaign?.contractPlaceholder?.flags?.hasHistory && (
                            <Tab label={t('brand.campaign.book.offer.modal.history')} value="5" />
                        )}
                    </TabList>
                </Box>
                <Box className="modal-right-content px-md-3">
                    <TabPanel value="0">
                        {!isAnnexMode && (
                            <ContractAnnexPending
                                contract={campaign?.contracts?.[0]}
                                signedByAgency={!!campaign?.contracts?.[0]?.user?.agencyCompany?.id}
                                onView={() => dispatch(setActiveTab('6'))}
                            />
                        )}
                        <AnnexBaseTab side="brand">
                            <ContractTab />
                        </AnnexBaseTab>
                    </TabPanel>
                    {hasAnnexTab && (
                        <TabPanel value="6">
                            <ContractTab />
                        </TabPanel>
                    )}
                    <TabPanel value="1">
                        <ContractIdeaContent />
                    </TabPanel>
                    <TabPanel value="2">
                        <ContractAudienceData />
                    </TabPanel>
                    {/* {!isClient && !isProposed && (
                        <TabPanel value="3">
                            <ContractReviews />
                        </TabPanel>
                    )} */}
                    {!isInvited && !isClient && !isProposed && (
                        <TabPanel className="h-100" value="4">
                            <OfferComments
                                isContract={true}
                                canWriteComment={canWriteComment}
                                offerId={campaign?.contracts[0]?.id ?? 0}
                            />
                        </TabPanel>
                    )}
                    {!isClient && campaign?.contractPlaceholder?.flags?.hasHistory && (
                        <TabPanel value="5">
                            <ContractHistory />
                        </TabPanel>
                    )}
                </Box>
            </TabContext>
        </Box>
    );
}

export default ContractModalTabs;
